import { SortMethods } from '../../../../../../../modules/sortAndFilter/config/SortAndFilterConfig';

/**
 * Gets the sorting option from the url, or returns the default sort.
 */
const getSortFromUrl = (key: string) => {
    if (typeof window === 'undefined') {
        return null;
    }

    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(`sort.${key}`) as SortMethods | null;
};

export default getSortFromUrl;
